import { observer } from "mobx-react";
import Scaffold from "../../../../components/Scaffold";
import CouponsStore from "../../../../stores/couponsStore";
import {Button, DatePicker, Drawer, Flex, Form, Input, Table} from "antd";
import { useEffect } from "react";
import DropdownActions from "../../../../components/DropdownActions";
import Utils from "../../../../utils/Utils";
import dayjs from "dayjs";

const store = new CouponsStore();

const AdminCouponsView = observer(() => {
  const [form] = Form.useForm();

  useEffect(() => {
    store.findAll();
    return () => {
      store.data = undefined;
    };
  }, []);

  const onCreate = () => {
    form.resetFields();
    store.state = "Create";
  };

  const onEdit = async (id: string) => {
    await store.findOne(id);
    form.setFieldsValue(store.item);
    store.state = "Edit";
  };

  const onCancel = () => {
    form.resetFields();
    store.state = "None";
  };

  const onRemove = async (id: string) => {
    await store.onRemove(id);
  };

  const onCodeGenerate = () => {
    const code = store.generatePromoCode();
    form.setFieldValue("value", code);
  };

  const onConfirm = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      if (store.state === "Create") {
        await store.onCreate(values);
      }

      if (store.state === "Edit") {
        await store.onUpdate(values);
      }

      store.findAll();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      <Scaffold
        title="Купоны"
        trailing={
          <Flex gap={12}>
            <Button onClick={onCreate} type="primary">
              Добавить
            </Button>
            <Input style={{ width: 220 }} placeholder="Поиск" value={store.search} onChange={(e) => (store.search = e.target.value)} />
          </Flex>
        }
      >
        <div style={{ height: 12 }} />
        <Table
          dataSource={store.filteredResults}
          rowKey={(e) => e.id}
          pagination={false}
          style={{ borderTop: "1px solid var(--night100)" }}
          loading={!store.data}
          scroll={{ y: "calc(100vh - 205px)" }}
          columns={[
            {
              title: "Название",
              dataIndex: "value",
            },
            {
              title: "Клиент",
              render: (_, i) =>
                i.user ? (
                  <div>
                    <div>{`${i.user?.profile.lastName} ${i.user.profile.firstName}`}</div>
                    <div style={{ fontSize: 12 }}>{i.user.email}</div>
                  </div>
                ) : (
                  "-"
                ),
            },
            {
              title: "Примечание",
              render: (_, i) =>
                <div>
                  <div style={{ fontSize: 12 }}>{i.note}</div>
                </div>
            },
            {
              title: "Статус",
              align: "center",
              width: 140,
              render: (_, i) => (
                <div
                  style={{
                    color: i.user ? "white" : "var(--night500)",
                    padding: "3px 6px",
                    backgroundColor: i.user ? "var(--green)" : "var(--night100)",
                    fontWeight: 500,
                    borderRadius: 4,
                  }}
                >
                  {i.user ? "Применен" : "Ожидание"}
                </div>
              ),
            },
            {
              title: "Дата создания",
              width: 200,
              align: "center",
              render: (_, i) => Utils.format(i.createdAt, "DD.MM.YYYY"),
            },
            {
              title: "Действителен по",
              width: 200,
              align: "center",
                render: (_, i) => {
                    if (i.expirationDate) {
                        const isExpired = dayjs(i.expirationDate).isBefore(dayjs());
                        const color = isExpired ? "var(--fury)" : "var(--night900)";
                        return <div style={{ color, fontWeight: 500 }}>{`${Utils.format(i.expirationDate, "DD.MM.YYYY")}`}</div>;
                    }

                    return "-";
                },
            },
            {
              title: " ",
              width: 70,
              render: (_, i) => <DropdownActions onEdit={async () => onEdit(i.id)} onDelete={async () => onRemove(i.id)} />,
            },
          ]}
        />
        <Drawer
          title={"Добавить купон"}
          open={store.state !== "None"}
          width={720}
          onClose={onCancel}
          footer={
            <Flex justify="flex-start" gap={12}>
              <Button disabled={store.isLoading} type="primary" onClick={onConfirm}>
                Сохранить
              </Button>
              <Button disabled={store.isLoading} onClick={onCancel}>
                Отменить
              </Button>
            </Flex>
          }
        >
          <Form layout="vertical" form={form}>
            <Form.Item name="value" label="Значение" rules={[{ required: true, message: " " }]}>
              <Input placeholder="Введите значение" />
            </Form.Item>
            <Button style={{ marginBottom: 16 }} onClick={onCodeGenerate}>
              Генерация кода
            </Button>
            <Form.Item
                name={"expirationDate"}
                label="Укажите срок"
                getValueProps={(value) => {
                    return { value: value ? dayjs(value) : undefined };
                }}
            >
                <DatePicker format={"DD-MM-YYYY"} />
            </Form.Item>
          </Form>
        </Drawer>
      </Scaffold>
    </div>
  );
});

export default AdminCouponsView;
